import { digger } from '@cbre/digger';
import { defaultTxt, simpleValueValidation } from '@miq/utils';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { getRegularOrColloquialVal } from '../../template-lov-attributes.const';
import { DisplayFunctionOptions, LovValues } from '../../../../models/template.model';
import { ReportRecord } from '../../../../models/report.model';

function ratingTypeLov(options: DisplayFunctionOptions): Observable<LovValues[]> {
  const { locale, reportExportViewService } = options;
  let result: Observable<LovValues[]>;
  const lookup = `/lookup/ref/country?lookupcategory=MIQ_EXTERNAL_RATING_TYPE&locale=${locale}`;
  result = reportExportViewService.getLovValues(lookup);
  return result;
}

function ratingLevelLov(options: DisplayFunctionOptions, reqPayload: string | string[]): Observable<LovValues[]> {
  const { locale, reportExportViewService } = options;
  return reportExportViewService.retrieveLovValues(
    `/ref/cascade/property/ratingLevel?locale=${locale}`,
    reqPayload
  ) as Observable<LovValues[]>;
}

export function getCertificates(record: ReportRecord, options, _ratingType, _certLevel) {
  const propertyRatingsPath = 'data.property_external_ratings';
  const ratingsData = digger(record, propertyRatingsPath);
  return ratingTypeLov(options).pipe(
    switchMap((ratingTypeLov: LovValues[]) => {
      const mappedTypes: LovValues[] = (ratingsData || []).map(rating => {
        const { green_building_rating_type_desc } = rating;
        const mappedType = getRegularOrColloquialVal(green_building_rating_type_desc, ratingTypeLov);
        if (!simpleValueValidation(mappedType)) {
          return null;
        }
        return { key: green_building_rating_type_desc, value: mappedType };
      });
      const ratingTypes = mappedTypes.filter(val => val != null && val.key != null).map(val => val.key);
      const ratings$ = ratingLevelLov(options, ratingTypes).pipe(
        map((ratingLevelLov: LovValues[]) => {
          const mappedRatings = (ratingsData || []).map((rating, i) => {
            const { green_building_cert_level_desc } = rating;
            const mappedLevel = getRegularOrColloquialVal(green_building_cert_level_desc, ratingLevelLov);
            if (!simpleValueValidation(mappedLevel)) {
              return null;
            }
            return `${mappedTypes[i].value || defaultTxt} ${mappedLevel || defaultTxt}`;
          });
          // show max of 3 values
          const max = mappedRatings.length < 4 ? mappedRatings.length : 3;
          return mappedRatings
            .filter(val => val != null)
            .slice(0, max)
            .join(', ');
        })
      );
      return ratings$;
    })
  );
}

export const emeaSpecificationCertificatesDisplayFunctions = {
  469: {
    // 469 - Certificates (Finland)
    displayFn: getCertificates,
  },
  383: {
    // 383 - Certificates (Italy)
    displayFn: getCertificates,
  },
  488: {
    // 488 - Certificates (Norway)
    displayFn: getCertificates,
  },
  364: {
    // 364 - Certificates (Poland)
    displayFn: getCertificates,
  },
  450: {
    // 450 - Certificates (Sweden)
    displayFn: getCertificates,
  },
};
